import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFoundPage from './error/NotFoundPage';
import ErrorPage from './error/ErrorPage';
import ClientsPage from './clients/ClientsPage';
import { ErrorBoundary } from '@/components/errorBoundary/ErrorBoundary';
import CreateClientsPage from "@/pages/clients/CreateClientsPage";
import ScopesPage from "@/pages/scopes/ScopesPage";

const BASE_PATH = '/';
const CLIENTS_PATH = `${BASE_PATH}clients`;
const CREATE_CLIENTS_PATH = `${BASE_PATH}client/create`;
const SCOPES_PATH = `${BASE_PATH}scopes`;
const ERROR_PATH = `${BASE_PATH}error`;

const Router: React.FC = () => {
  return (
    <Routes>
      <Route path={BASE_PATH} element={<ClientsPage />} />
      <Route path={CLIENTS_PATH} element={<ClientsPage />} />
      <Route path={CREATE_CLIENTS_PATH} element={<CreateClientsPage />} />
      <Route path={SCOPES_PATH} element={<ScopesPage />} />
      <Route
        path={ERROR_PATH}
        element={
          <ErrorBoundary fallback={(error) => <div>Render Error! {JSON.stringify(error)}</div>}>
            <ErrorPage />
          </ErrorBoundary>
        }
      />
      <Route element={<NotFoundPage />} />
    </Routes>
  );
};

export default Router;
export { BASE_PATH, ERROR_PATH, CLIENTS_PATH, SCOPES_PATH, CREATE_CLIENTS_PATH };
